import { render } from "./EventDetails.vue?vue&type=template&id=a2bac74e&scoped=true"
import script from "./EventDetails.vue?vue&type=script&lang=js"
export * from "./EventDetails.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-a2bac74e"

export default script